import classNames from "classnames";
import React from "react";

import styles from "./Label.module.scss";

interface Props {
  label: string;
  labelSize?: "medium" | "small";
  boxSize?: "mediumBox" | "smallBox";
}

class Label extends React.PureComponent<Props> {
  public render() {
    const { boxSize = "medium", label, labelSize = "mediumBox" } = this.props;
    const labelClass = classNames(styles[labelSize]);
    const containerClass = classNames(styles[boxSize]);
    return (
      <div className={containerClass}>
        <p className={labelClass}>{label}</p>
      </div>
    );
  }
}

export default Label;
